export default __webpack_public_path__ + "static/media/workshops_titleResized.5035dbb3.png";